/**
 * Prepare file name with extension in brackets.
 *
 * @param value raw file name.
 * @return String with file name and file extension in brackets.
 */
export function prepareFileName(value) {
    return getFileName(value).concat(' (', getFileExtension(value), ')');
}

function getFileExtension(value) {
    return value.split('.').pop().toUpperCase();
}

function getFileName(value) {
    return value.substr(0, value.lastIndexOf('.'));
}


// WEBPACK FOOTER //
// ./src/utils/FileName.js